<template>
  <div class="editor-item">
    <editor-header
      :showSettings="false"
      :hasHelper="contentItem.has_helper"
      :title="$t('builder.recent_assets')"
    />
  </div>
</template>

<script>
export default {
  name: 'RecentAssets',
  props: ['contentItem'],
  data () {
    return {
      isVisible: true
    }
  }
}
</script>
